export default __webpack_public_path__ + "static/newaccount-9311262470e1c4a539849965843cb4b6.png";